
import { createReducer, on } from '@ngrx/store';
import { MemberProfile } from '../model/member-profile.model';
import { MemberProfileActions } from './member-profile-action.types';

const initialMemberProfileState: MemberProfile = null;

export const memberProfileReducer = createReducer(

  initialMemberProfileState,

  on(MemberProfileActions.SetMemberProfile, (state, memberProfile: MemberProfile) => {
    return ({ ...state, ...memberProfile });
  }),

  on(MemberProfileActions.UnsetMemberProfile, () => {
    return initialMemberProfileState;
  })
);